module.exports = __webpack_public_path__ + "static/img/TrebuchetMS.a367935.svg";